import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';
import { Button } from '@fetmode/ui';
import { Link } from 'react-router-dom';

import { SettingsStack } from './SettingsStack.js';

export function SettingsPayoutsPage(): ReactElement {
  return (
    <SettingsStack titleKey="common.studio.settings.payoutsTitle" hintKey="common.studio.settings.payoutsHint">
      <div className="fm-card">
        <h2 style={{ marginTop: 0, fontSize: '1.125rem' }}>{t('common.studio.settings.payoutMethodTitle')}</h2>
        <p style={{ margin: '0 0 1rem', color: 'var(--fm-color-text-muted)', fontSize: '0.875rem' }}>
          {t('common.studio.settings.payoutMethodHint')}
        </p>
        <ul style={{ margin: 0, paddingLeft: '1.2rem', color: 'var(--fm-color-text-muted)', fontSize: '0.875rem' }}>
          <li>{t('common.studio.settings.payoutRailAch')}</li>
          <li>{t('common.studio.settings.payoutRailDebit')}</li>
          <li>{t('common.studio.settings.payoutRailCrypto')}</li>
        </ul>
        <p style={{ margin: '1rem 0 0', fontSize: '0.875rem' }}>
          {t('common.studio.settings.payoutNotConnected')}
        </p>
      </div>
      <div className="fm-card">
        <h2 style={{ marginTop: 0, fontSize: '1.125rem' }}>{t('common.studio.settings.payoutScheduleTitle')}</h2>
        <p style={{ margin: 0, color: 'var(--fm-color-text-muted)', fontSize: '0.875rem' }}>
          {t('common.studio.settings.payoutScheduleHint')}
        </p>
      </div>
      <div className="fm-card">
        <h2 style={{ marginTop: 0, fontSize: '1.125rem' }}>{t('common.studio.settings.statementsTitle')}</h2>
        <p style={{ margin: '0 0 1rem', color: 'var(--fm-color-text-muted)', fontSize: '0.875rem' }}>
          {t('common.studio.settings.statementsEmpty')}
        </p>
        <Link to="/wallet">
          <Button label={t('common.studio.settings.openWallet')} variant="secondary" />
        </Link>
      </div>
    </SettingsStack>
  );
}
